import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "label" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "items" }

import { VIconSvg, VInputCheckbox } from "@/components";
import VErrorTooltip from "../VErrorTooltip/VErrorTooltip.vue";
import { computed } from "vue";

export interface Props {
  label: string;
  value?: [string][number][];
  options: Array<{
    label: string;
    code: string;
  }>;
  disabled?: boolean;
  disabledItems?: Array<string>;
  trackBy?: string;
  itemLabel?: string;
  required?: boolean;
  error?: string;
  description?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VInputCheckboxGroup',
  props: {
    label: { default: "" },
    value: { default: () => [] },
    options: { default: () => [
    {
      label: "",
      code: "",
    },
  ] },
    disabled: { type: Boolean, default: false },
    disabledItems: { default: () => [] },
    trackBy: { default: "code" },
    itemLabel: { default: "label" },
    required: { type: Boolean, default: false },
    error: { default: "" },
    description: { default: "" }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const selectOptions = computed(() => {
  return props.options.map((item) => ({
    ...item,
    selected: props.value.includes(item[props.trackBy]),
  }));
});

const inputWrapperClasses = computed(() => {
  const classes = {
    "input-error": props.error,
    "input-required": props.required,
  };

  return [classes];
});

const isShownInfoIcon = computed(() => {
  return !!props.description;
});

const disabledItem = (code: string) => {
  return props.disabled || props.disabledItems.includes(code);
};

const onClickItem = (value: boolean, index: number) => {
  const options = [...selectOptions.value];

  options[index].selected = value;
  const selected = options.filter(({ selected }) => selected).map((item) => item[props.trackBy]);

  emit("input", selected);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-checkbox-group", inputWrapperClasses.value])
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
      (isShownInfoIcon.value)
        ? (_openBlock(), _createBlock(_unref(VIconSvg), {
            key: 0,
            tooltip: _ctx.description,
            name: "InfoCircle2",
            color: "fc-stroke",
            size: "xs"
          }, null, 8, ["tooltip"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectOptions.value, (option, index) => {
        return (_openBlock(), _createBlock(_unref(VInputCheckbox), {
          key: index,
          label: option[_ctx.itemLabel],
          disabled: disabledItem(option.code),
          value: option.selected,
          onInput: ($event: any) => (onClickItem($event, index))
        }, null, 8, ["label", "disabled", "value", "onInput"]))
      }), 128))
    ]),
    (_ctx.error)
      ? (_openBlock(), _createBlock(VErrorTooltip, {
          key: 0,
          error: _ctx.error
        }, null, 8, ["error"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})